import { ComponentPropsWithoutRef, useEffect, useRef, useState } from 'react';

import classNames from 'classnames';

import { Collapse } from '@uikit/components/Collapse';

interface Props extends ComponentPropsWithoutRef<'p'> {
  text: string;
  maxLines?: number;
  buttonClassname?: string;
}

const ClampTextWithReadMore = ({ text, maxLines = 2, buttonClassname, ...props }: Props) => {
  const [isClamped, setIsClamped] = useState(false);
  const [extended, setExtended] = useState(false);
  const clampRef = useRef<HTMLDivElement>(null);
  // Disabled collapse animation to prevent issue with min-height
  // when element collapse from full height to min-height on mount
  const [isAnimationEnabled, setIsAnimationEnabled] = useState(false);

  useEffect(() => {
    if (clampRef.current) {
      const computedStyle = window.getComputedStyle(clampRef.current);
      const lineHeight = parseInt(computedStyle.lineHeight);
      const maxHeight = maxLines * lineHeight;

      if (clampRef.current.scrollHeight > maxHeight) {
        setIsClamped(true);
      }
    }
  }, [text, clampRef, maxLines]);

  const toggleExtended = () => {
    if (!isAnimationEnabled) {
      setIsAnimationEnabled(true);
    }

    setIsClamped((prev) => !prev);
    setExtended((prev) => !prev);
  };

  const isOpen = !isClamped || extended;
  const showShowMoreButton = isClamped || extended;

  return (
    <div className="flex flex-col gap-6">
      <Collapse
        isOpen={isOpen}
        style={{
          ...(!isAnimationEnabled ? { transitionDuration: '0ms' } : {}),
        }}
        wrapperBoxProps={{
          style: {
            minHeight: showShowMoreButton ? `${maxLines * 1.25}em` : 'none', // Adjust as needed
          },
        }}
      >
        <div ref={clampRef} {...props} dangerouslySetInnerHTML={{ __html: text }} />
      </Collapse>

      {showShowMoreButton && (
        <button
          className={classNames('button button-solid-mono rounded-xl h-10', buttonClassname)}
          onClick={toggleExtended}
        >
          {extended ? 'Show Less' : 'Show More'}
        </button>
      )}
    </div>
  );
};

export default ClampTextWithReadMore;
